<template>


  <div id="app">

    
    <!-- <privacy-modal /> -->
    <html-top ref="htmltop" />
    <nav-menu />
    <router-view />
    <html-footer />
  </div>
</template>

<script>
import HtmlFooter from "./components/common/HtmlFooter.vue";
import HtmlTop from "./components/common/HtmlTop.vue";
import NavMenu from "./components/common/NavMenu.vue";
// import PrivacyModal from "./components/index/PrivacyModal.vue";

export default {
  name: "App",
  components: {
    HtmlFooter,
    HtmlTop,
    NavMenu
  },
  data(){            
      return {
          ua:navigator.userAgent.toLowerCase()
          
      }
  },
  methods:{
    isMobile() {
      const ua = navigator.userAgent.toLowerCase();

      const isWeChat = /wechat/.test(ua); // 是否是微信浏览器
      console.log(ua);
      // const isWeChatPC = isWeChat && (/windows/.test(ua) || /mac/.test(ua)); // 是否是PC端微信
      const isMobileDevice = /(phone|pad|pod|iphone|ipod|ios|ipad|android|mobile|blackberry|iemobile|mqqbrowser|juc|fennec|wosbrowser|browserng|webos|symbian|windows phone)/.test(ua);

      return isMobileDevice || isWeChat;
    }
  },


  // watch: {
  //   windowWidth(val) {
  //     if (val < 768) {
  //       window.open("https://wap.movibot-art.com/");
  //     }
  //   }
  // }
  mounted() {
    this.$nextTick(() => {
       if (this.isMobile()) {
          window.location.href = "https://wap.movibot-art.com/";
        }
    });

    // ===== 多标签页对比列表同步（防止切换标签页时相互覆盖） =====
    // 触发同步：从 localStorage 重新读取对比列表到 Vuex
    this.syncCompareList = () => {
      this.$store.commit('syncCompareFromStorage');
    };
    // 其他标签页修改了对比列表时实时同步（storage 事件只在"其他"标签页触发）
    this.onStorageChange = (e) => {
      // 只处理对比列表的变化（e.key 为 null 表示 clear()清空）
      if (e.key !== null && e.key !== 'compareList') return;
      this.syncCompareList();
    };
    // 进入页面时先刷新一次
    this.syncCompareList();
    window.addEventListener('storage', this.onStorageChange);
    // 切换标签页回来时刷新（防止 storage 事件遗漏的场景）
    document.addEventListener('visibilitychange', this.syncCompareList);
  },
  // 组件销毁时移除事件监听，避免内存泄漏
  beforeDestroy() {
    window.removeEventListener('storage', this.onStorageChange);
    document.removeEventListener('visibilitychange', this.syncCompareList);
  }

    // this.$nextTick(() => {
    //   var appDivWidth = window.innerWidth;
    //   console.log(appDivWidth, "appDivWidth");
    //   if (appDivWidth < 1201) {
    //     window.location.href = "https://wap.movibot-art.com/";
    //     // var tempwindow = window.open("_blank"); //打开一个窗口，然后用

    //     // tempwindow.location = "https://wap.movibot-art.com/";
    //   }
    // });
  
};
</script>
<style>
.el-dropdown-menu__item:hover {
  background-color: #fff !important;
  color: #2655ae !important;
}
#app {
  min-width: 1200px;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue